import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

import { LoginCredential } from 'src/app/models/login/login-credential';
import { HttpService } from '../http/http.service';
import { UserService } from '../user/user.service';
import { PermissionService } from '../user/permission.service';

@Injectable()
export class LoginService extends HttpService {

    constructor(private readonly cookieService: CookieService, private readonly router: Router, private readonly userService: UserService, private readonly permissionService: PermissionService) {
        super();
    }

    public isLoggedIn(): boolean {
        if (this.userService.isActiveToken()) {
            const token = this.userService.getUserToken();
            const currentCenter = this.userService.getCenter().center;

            const user = this.userService.getUserToken();

            if (!token || !currentCenter || !user) {
                return false;
            }

            return true;
        }

        return false;
    }

    login(loginCredential: LoginCredential, language: string, recaptcha: string, urlQuery: string): Observable<unknown> {
        const url = 'staff/login' + (urlQuery !== '' ? '/' + urlQuery : '');

        return this.post(`${url}?language_code=${language}&recaptcha=${recaptcha}`,
            { app: 'center', version: 1 }, loginCredential, this.noShowErrorNotification);
    }

    logout(): void {
        this.cookieService.deleteAll();
        this.permissionService.removePermissions();
        void this.router.navigateByUrl('/login').then(() => {
            window.location.reload();
        });
    }
}
